// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"65d81393","82":"40760394","463":"71eb9ecd","613":"8008cd86","707":"51fd7d64","748":"b089621a"}[chunkId] + ".chunk.css";
};